<template>
  <div class="error-page">
    <i class="el-icon-warning" />
    <h2 class="not-found">
      {{ $t('NO DATA') }}
    </h2>
    <router-link to="/">
      {{ $t('Go Home') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Error'
};
</script>

<style lang="scss">
.error-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10%;

  i {
    font-size: 30px;
  }

  .not-found {
    display: flex;
    align-items: center;
  }

  a {
    font-weight: bold;
    text-decoration: none;
  }
}
</style>
